const initScrollDirection = () => {
    // We use a positive number here because window.scrollY starts at 0
    // and increases as you scroll down.
    const body = document.querySelector('.js-body');
    const { page } = body.dataset;

    let scrollThreshold;

    if (page === 'home') {
        scrollThreshold = 2 * window.innerHeight;
    } else {
        scrollThreshold = 50;
    }

    let lastScrollPosition = window.scrollY;
    let ticking = false;

    document.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const currentScroll = window.scrollY;

                // 1. Check if we've passed the threshold
                if (currentScroll > scrollThreshold) {
                    // 2. Check Direction
                    if (currentScroll < lastScrollPosition) {
                        document.body.setAttribute('data-scroll-direction', 'up');
                    } else {
                        document.body.setAttribute('data-scroll-direction', 'down');
                    }

                    document.body.setAttribute('data-scrolled', 'true');
                } else {
                    // We are at the very top (within the 80px buffer)
                    document.body.setAttribute('data-scroll-direction', 'top');
                    document.body.setAttribute('data-scrolled', 'false');
                }

                // 3. Update position for the next frame
                lastScrollPosition = currentScroll;
                ticking = false;
            });

            ticking = true;
        }
    }, { passive: true }); // Better performance for scroll listeners
};

export { initScrollDirection as default };
